import styled from 'styled-components';
import { Button as ButtonComponent } from 'junto-ui';
import { tokens, palette } from '@plataforma/components';

import { fonts, grid, colors } from '_/styles';

const colorsMatch = {
  inProgress: {
    // EM ABERTO
    text: colors.baseGray,
    background: colors.baseGrayLight
  },
  policyIssued: {
    // VIGENTE
    text: colors.baseGreen,
    background: colors.baseGreenLight
  },
  canceled: {
    // CANCELADA
    text: colors.baseRed,
    background: colors.baseRedLight
  },
  underAnalysis: {
    // EM ANALISE
    text: colors.baseBlue,
    background: colors.baseBlueLight
  },
  renew: {
    // A VENCER
    text: colors.baseOrange,
    background: colors.baseOrangeLight
  },
  processing: {
    // PROCESSANDO
    text: colors.basePurple,
    background: colors.basePurpleLight
  },
  default: {
    text: colors.baseGray,
    background: colors.baseGrayLight
  }
};

export const Card = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* min-height: 186px; */
  appearance: none;
  cursor: pointer;
  border: solid 1px ${colors.divider};
  background: ${colors.white};
  border-radius: ${grid.radius};
  margin-bottom: ${grid.regular};
  transition: box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out;

  &:hover {
    box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.15);
    border-color: ${colors.background};
  }
`;

export const InfoBlock = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: ${grid.medium};
`;

export const ActionBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${grid.medium};
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  max-height: 24px;
`;

export const Body = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-start;
  margin-top: 16px;
`;

export const Status = styled.span`
  color: ${({ status }) =>
    (colorsMatch[status] && colorsMatch[status].text) ||
    colorsMatch.default.text};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  font-size: ${fonts.size.small};
  font-weight: ${tokens.font.weight.semibold};
  height: 24px;
  border-radius: 12px;
  background: ${({ status }) =>
    (colorsMatch[status] && colorsMatch[status].background) ||
    colorsMatch.default.background};
`;

export const Title = styled.h1`
  color: ${colors.textMain};
  font-weight: ${tokens.font.weight.semibold};
  font-size: ${fonts.size.medium};
  margin-left: ${grid.regular};
`;

export const Menu = styled.div`
  margin-left: auto;
  margin-right: -8px;
`;

export const Content = styled.div`
  flex: 1;
  align-self: flex-start;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: ${grid.small};
  row-gap: ${grid.regular};
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.span`
  color: ${colors.textComplementary};
  font-size: ${fonts.size.small};
  line-height: 1.4;
  margin-bottom: ${grid.small};
`;

export const Value = styled.span`
  color: ${colors.textMain};
  font-size: ${fonts.size.default};
  line-height: 1.5;
`;

export const Button = styled(ButtonComponent)`
  width: 165px;
  margin-right: ${grid.small};
  margin-top: ${grid.small};
  font-family: ${tokens.font.family.metropolis};
  font-weight: ${tokens.font.weight.semibold};
`;

export const ButtonContainer = styled.div`
  min-width: 165px;
`;

export const Endorsement = styled.span`
  position: relative;
  top: 10px;
  color: ${colors.baseBlue};
  font-size: ${fonts.size.regular};
  font-weight: ${tokens.font.weight.semibold};
`;

export const DownloadButton = styled.div`
  margin-top: 16px;
  margin-left: 114px;
  color: ${colors.electricViolet};
  font-weight: ${tokens.font.weight.semibold};
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: start;
  cursor: pointer;
  width: 127px;

  svg {
    margin-right: 8px;
  }
`;

export const labelButtonDownload = styled.span`
  color: ${palette['color-brand-primary']};
  ${tokens.font['xs-emphasys']};
`;
